import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  EventTicketTierDto,
  CreateEventTicketTierDto,
  ResponseDto,
} from "@mimber/schema"
import { eventTicketTiersKeys } from "../events.utils"

export const useCreateEventTicketTier = (
  eventUuid: string,
  options?: UseMutationOptions<
    ResponseDto<EventTicketTierDto>,
    Error,
    CreateEventTicketTierDto
  >
): UseMutationResult<
  ResponseDto<EventTicketTierDto>,
  Error,
  CreateEventTicketTierDto
> => {
  guardAppUsage("mimber-organization", "useCreateEventTicketTier")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (data: CreateEventTicketTierDto) => {
      const response = await server.post<ResponseDto<EventTicketTierDto>>(
        `events/${eventUuid}/ticket-tiers`,
        data
      )
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: eventTicketTiersKeys.findAll(eventUuid),
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
